<template>
  <div class="plan-edit-menu p-2 text-left text-sm absolute mt-8">
    <ul>
      <li>
        <a v-on:click="$emit('changeVisit')">
          <img src="@/assets/images/icon-menu-time.svg" :alt="$t('tour_hour_label')" />
          <span class="ml-1">{{ $t('tour_change_arrival_and_stay') }}</span>
        </a>
      </li>
      <li v-if="!place.lock">
        <a v-on:click="$emit('deleteDestination')">
          <img src="@/assets/images/icon-menu-delete.svg" :alt="$t('tour_remove_label')" />
          <span class="ml-1">{{ $t('tour_remove_destination') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>
